export const enum ExpectedStringType {
	String,
	DateTime,
	Date,
	Time,
	Currency,
}
